import React from 'react';
import {useOutlet} from 'reconnect.js';
import styled from 'styled-components';
import * as AppActions from '../../AppActions';
import {CONTACT} from '../../constants';
import {message} from 'antd';

let LINK_ITEMS = [
  {
    title: '關於Pinbar',
    to: '/about',
    loading: 500,
    public: true,
    items: [
      {
        title: '關於Pinbar',
        to: '/about#intro',
        loading: 300,
        public: true,
      },
      {
        title: '產品服務',
        to: '/about#service-flow',
        loading: 300,
        public: true,
      },
      {
        title: '常見問題',
        to: '/faq',
        loading: 300,
        public: true,
      },
    ],
  },
  {
    title: '商品項目',
    to: '/products',
    loading: true,
    public: true,
    items: [
      {
        title: '客製化拼圖',
        to: '/products?cat=custom',
        loading: true,
        public: true,
      },
      {
        title: '零售拼圖',
        to: '/products?cat=theme',
        loading: true,
        public: true,
      },
      {
        title: '客製化樂高',
        to: '/products?cat=custom-lego',
        loading: true,
        public: false,
      },
      {
        title: '零售樂高',
        to: '/products?cat=theme-lego',
        loading: true,
        public: false,
      },
    ],
  },
  {
    title: '部落格',
    to: '/articles',
    loading: true,
    public: true,
    items: [
      {
        title: '最新消息',
        to: '/articles/?cat=news',
        loading: true,
        public: true,
      },
    ],
  },
];

function SiteFooter(props) {
  const [dimension] = useOutlet('dimension');

  return (
    <FlexItemSection isMobile={!(dimension.rwd === 'desktop')}>
      <div
        className="content-section"
        style={{
          padding: 30,
          flexDirection: dimension.rwd === 'desktop' ? 'row' : 'column',
        }}>
        <div className="constrain">
          <h2
            onClick={() => AppActions.navigate('/', {loading: true})}
            style={{flex: 1, textAlign: 'center'}}>
            <img
              src="/images/pinbar-logo.png"
              alt="Logo"
              style={{
                height: 150,
                objectFit: 'contain',
              }}
            />
          </h2>

          <div
            className="info"
            style={{
              display: 'flex',
              flex: 4,
              marginTop: dimension.rwd === 'desktop' ? 0 : 40,
              justifyContent: 'space-around',
            }}>
            {LINK_ITEMS.map((item, index) => (
              <div
                key={index}
                style={{minWidth: dimension.rwd === 'desktop' ? 120 : 85}}>
                <div
                  className="link-title"
                  style={{color: '#aace2d', fontSize: 20, cursor: 'pointer'}}
                  onClick={() =>
                    AppActions.navigate(item.to, {loading: item.loading})
                  }>
                  {item.title}
                </div>
                {item.items.map((i, idx) => (
                  <div
                    key={idx}
                    className="link-item"
                    onClick={() => {
                      if (!i.public) {
                        message.info('尚未開放，敬請期待!');
                        return;
                      }
                      AppActions.navigate(i.to, {loading: i.loading});
                    }}>
                    {i.title}
                  </div>
                ))}
              </div>
            ))}
          </div>
          <div
            className="info"
            style={{
              flex: 1,
              alignSelf: 'stretch',
              marginTop: dimension.rwd === 'desktop' ? 0 : 40,
            }}>
            <p className="link-title" style={{fontSize: 15, color: '#505050'}}>
              {' '}
              聯絡我們
            </p>
            <p className="info-text">
              <a
                style={{textDecoration: 'none', color: '#707070'}}
                href={'mailto:' + CONTACT.email}>
                {CONTACT.email}
              </a>
            </p>
            <p className="info-text">
              <a
                style={{textDecoration: 'none', color: '#707070'}}
                href={'tel:' + CONTACT.phone[1]}>
                {CONTACT.phone[0]}
              </a>
            </p>
            {CONTACT.address && <p className="info-text">{CONTACT.address}</p>}
            <p className="info-text">{CONTACT.time}</p>

            <div
              className="info"
              style={{
                maxWidth: 280,
                justifyContent:
                  dimension.rwd === 'desktop' ? 'flex-end' : 'center',
                marginTop: 40,
              }}>
              <a
                href="https://www.facebook.com/Pinbar%E6%8B%BC%E5%90%A7-107651678457081"
                target="_blank"
                rel="noreferrer">
                <img
                  src="/images/fb.png"
                  alt="Logo"
                  style={{height: 40, objectFit: 'contain'}}
                />
              </a>
              <a
                href="https://www.instagram.com/pinbar.tw/"
                target="_blank"
                rel="noreferrer">
                <img
                  src="/images/ig.png"
                  alt="Logo"
                  style={{height: 40, objectFit: 'contain', marginLeft: 15}}
                />
              </a>
              <a
                href="https://liff.line.me/1645278921-kWRPP32q/?accountId=pinbar"
                target="_blank"
                rel="noreferrer">
                <img
                  src="/images/line.png"
                  alt="Logo"
                  style={{height: 40, objectFit: 'contain', marginLeft: 15}}
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <CopyrightSection />
    </FlexItemSection>
  );
}

const CopyrightSection = () => {
  const [dimension] = useOutlet('dimension');

  if (dimension.rwd === 'desktop') {
    return (
      <div
        className="bottom-section"
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          height: 64,
          backgroundColor: 'white',
          color: '#aace2d',
        }}>
        2021 拼吧 Pinbar | Powered By&nbsp;
        <a
          style={{
            display: 'inline',
            fontSize: 12,
            color: '#14A58C',
          }}
          href="https://revteltech.pse.is/3psgrd"
          target="_blank"
          rel="noreferrer">
          奕果雲端數位 EcultureTech
        </a>
      </div>
    );
  } else {
    return (
      <div className="bottom-section">
        <div
          className="constrain"
          style={{
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
          <div>2021 拼吧 Pinbar</div>
          <div style={{verticalAlign: 'middle', marginTop: 8}}>
            <div
              style={{
                display: 'inline',
                color: 'grey',
                marginRight: 5,
                fontSize: 10,
              }}>
              Powered By
            </div>
            <a
              style={{
                display: 'inline',
                fontSize: 12,
                color: '#14A58C',
              }}
              href="https://revteltech.pse.is/3psgrd"
              target="_blank"
              rel="noreferrer">
              奕果雲端數位 EcultureTech
            </a>
          </div>
        </div>
      </div>
    );
  }
};

const FlexItemSection = styled.section`
  text-align: ${(props) => (props.isMobile ? 'center' : 'left')};
  & > .content {
    max-width: 1024px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
  }

  & .constrain {
    margin: 0 auto;
    max-width: var(--contentMaxWidth);
    display: flex;
    flex: 1;
    flex-direction: ${(props) => (props.isMobile ? 'column' : 'row')};
    /* align-items: center; */
  }

  & > .bottom-section {
    background-color: #f6f6f6;
    padding: 25px 40px;
    font-size: 13px;
  }

  & > .content-section {
    display: flex;

    & .info {
      flex-basis: 100px;
      & .info-text {
        color: #707070;
        margin-top: 8px;
        :first-child {
          margin-top: 0px;
        }
      }
      & img {
        cursor: pointer;
      }
    }

    & .link-title {
      font-size: 18px;
      font-weight: 500;
      margin-bottom: 20px;
    }

    & .link-item {
      padding: 5px 0px;
      cursor: pointer;
      font-size: 16px;
      transition: all 0.2s ease-out;
      white-space: break-spaces;
      text-align: ${(props) => (props.isMobile ? 'center' : 'left')};
      color: #707070;

      :hover {
        color: #000;
      }
    }

    & .social-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 35px;
      height: 35px;
      border: 1px solid #eee;
      border-radius: 20px;
    }
  }
`;

export default SiteFooter;
